<template>
  <div>
    <div style="margin-top: 40px;"></div>
    <div class="container">
      <div class="select-container">
        <el-select
          v-model="cuad_id"
          placeholder="Cuadrilla"
          clearable
          filterable
        >
          <el-option
            v-for="item in cuadrillas"
            :key="item.cuad_id"
            :label="item.cuad_descripcion"
            :value="item.cuad_id"
          >
          </el-option>
        </el-select>
      </div>

      <div class="switch-container">
        <span>Ubicación Más Reciente</span>
        <el-switch
          v-model="isInRoute"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
        <span>Ruta en una Fecha</span>
      </div>

      <div class="date-picker-container">
        <el-date-picker
          v-if="isInRoute === true"
          v-model="rast_fecha"
          type="date"
          placeholder="Seleccione el Día"
        >
        </el-date-picker>
      </div>

      <div class="button-container">
        <el-button
          :disabled="cuad_id === undefined || cuad_id === null || cuad_id < 0"
          type="primary"
          @click="handleBuscar()"
        >
          Buscar
        </el-button>
      </div>
    </div>
    <el-container>
      <GoogleMapCuadrillaLoader
        v-if="dataLoaded"
        :mapConfig="mapConfig"
        :apiKey="apiKey"
      >
        <template slot-scope="{ loader, map, google }">
          <GoogleMapCuadrillaPolyLine
            v-if="isInRoute"
            :loader="loader"
            :map="map"
            :google="google"
            :routes="markers"
          />
          <GoogleMapCuadrillaMarker
            v-else
            v-for="marker in markers"
            :key="marker.aap_id"
            :marker="marker"
            :loader="loader"
            :map="map"
            :google="google"
          />
        </template>
      </GoogleMapCuadrillaLoader>
    </el-container>
  </div>
</template>

<script>
  import GoogleMapCuadrillaLoader from '@/components/GoogleMapCuadrillaLoader'
  import GoogleMapCuadrillaMarker from '@/components/GoogleMapCuadrillaMarker'
  import GoogleMapCuadrillaPolyLine from '@/components/GoogleMapCuadrillaPolyLine'
  import {
    getCuadrillas,
    getCuadrillaUltimaPosicion,
    getCuadrillaRutaRastreo
  } from '@/api/cuadrilla'
  import { apiKey } from '@/api/google'

  export default {
    name: 'Geolocalizar',
    components: {
      GoogleMapCuadrillaLoader,
      GoogleMapCuadrillaMarker,
      GoogleMapCuadrillaPolyLine
    },
    data() {
      return {
        apiKey: null,
        markers: [],
        cuad_id: 0,
        cuadrillas: [],
        rast_fecha: null,
        isInRoute: false,
        dataLoaded: false
      }
    },
    beforeMount() {
      apiKey()
        .then(response => {
          this.apiKey = response.data
          console.log('apiKey:', this.apiKey)
          getCuadrillas().then(response => {
            this.cuadrillas = response.data
            this.cuadrillas.unshift({ cuad_id: 0, cuad_descripcion: 'Todas' })
            console.log('cuadrillas:', this.cuadrillas)
            this.setListeners()
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    methods: {
      setListeners() {
        const self = this
        window.addEventListener('show-more-details', function(event) {
          // Acceder al detalle enviado con el evento
          self.aap_id = event.detail.aap_id
          self.showMoreDetails()
        })
      },
      getMarkers() {
        const loading = this.$loading({
          lock: true,
          text: 'Examinado Datos...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        if (!this.isInRoute) {
          getCuadrillaUltimaPosicion(this.cuad_id)
            .then(response => {
              console.log('markers:', response.data)
              this.markers = response.data
              const marker = this.markers[0]
              this.center = {
                lat: parseFloat(marker.rast_lat),
                lng: parseFloat(marker.rast_lng)
              }
              this.dataLoaded = true
              loading.close()
            })
            .catch(error => {
              console.log(error)
              loading.close()
            })
        } else {
          const fecha = this.rast_fecha.getTime()
          getCuadrillaRutaRastreo(this.cuad_id, fecha)
            .then(response => {
              console.log('markers:', response.data)
              this.markers = response.data
              if (this.markers.length === 0) {
                this.$message({
                  message: 'No se encontraron datos para la fecha seleccionada',
                  type: 'warning'
                })
                loading.close()
                return
              }
              const marker = this.markers[0]
              this.center = {
                lat: parseFloat(marker.rast_lat),
                lng: parseFloat(marker.rast_lng)
              }
              this.dataLoaded = true
              loading.close()
            })
            .catch(error => {
              console.log(error)
              loading.close()
            })
        }
      },
      handleBuscar() {
        this.dataLoaded = false
        this.getMarkers()
      },
      showMoreDetails() {},
      getFotoData(url) {}
    },
    computed: {
      mapConfig() {
        return {
          center: this.center,
          zoom: 15,
          styles: [
            {
              elementType: 'geometry',
              stylers: [
                {
                  color: '#ebe3cd'
                }
              ]
            },
            {
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#523735'
                }
              ]
            },
            {
              elementType: 'labels.text.stroke',
              stylers: [
                {
                  color: '#f5f1e6'
                }
              ]
            },
            {
              featureType: 'administrative',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  color: '#c9b2a6'
                }
              ]
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  color: '#dcd2be'
                }
              ]
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#ae9e90'
                }
              ]
            },
            {
              featureType: 'landscape.natural',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#dfd2ae'
                }
              ]
            },
            {
              featureType: 'poi',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#dfd2ae'
                }
              ]
            },
            {
              featureType: 'poi',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#93817c'
                }
              ]
            },
            {
              featureType: 'poi.park',
              elementType: 'geometry.fill',
              stylers: [
                {
                  color: '#a5b076'
                }
              ]
            },
            {
              featureType: 'poi.park',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#447530'
                }
              ]
            },
            {
              featureType: 'road',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#f5f1e6'
                }
              ]
            },
            {
              featureType: 'road.arterial',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#fdfcf8'
                }
              ]
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#f8c967'
                }
              ]
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  color: '#e9bc62'
                }
              ]
            },
            {
              featureType: 'road.highway.controlled_access',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#e98d58'
                }
              ]
            },
            {
              featureType: 'road.highway.controlled_access',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  color: '#db8555'
                }
              ]
            },
            {
              featureType: 'road.local',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#806b63'
                }
              ]
            },
            {
              featureType: 'transit.line',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#dfd2ae'
                }
              ]
            },
            {
              featureType: 'transit.line',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#8f7d77'
                }
              ]
            },
            {
              featureType: 'transit.line',
              elementType: 'labels.text.stroke',
              stylers: [
                {
                  color: '#ebe3cd'
                }
              ]
            },
            {
              featureType: 'transit.station',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#dfd2ae'
                }
              ]
            },
            {
              featureType: 'water',
              elementType: 'geometry.fill',
              stylers: [
                {
                  color: '#b9d3c2'
                }
              ]
            },
            {
              featureType: 'water',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#92998d'
                }
              ]
            }
          ]
        }
      }
    }
  }
</script>
<style scoped>
  .last-photos {
    display: flex;
    flex-wrap: wrap;
  }

  .last-photos img {
    width: 100px;
    height: 100px;
    margin: 5px;
  }
  .container {
  display: flex;
  flex-direction: column;
  gap: 20px; /* Ajusta este valor para aumentar o disminuir el espacio entre los elementos */
}

.switch-container {
  display: flex;
  align-items: center;
  gap: 10px; /* Espacio entre los elementos dentro del contenedor del switch */
}

.select-container,.date-picker-container,.button-container {
  /* Puedes agregar estilos adicionales aquí si es necesario */
}
</style>
